import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowUpRight } from "lucide-react";
import { listLegalPages } from "@/admin/adminApi";

export default function AdminLegalPagesListPage() {
  const [pages, setPages] = useState(null);

  useEffect(() => { listLegalPages().then(setPages); }, []);

  if (!pages) return <p className="text-white/60 font-mono text-sm">Loading…</p>;

  return (
    <div data-testid="admin-legal-pages-list">
      <div className="flex items-center gap-2 mb-2">
        <FileText size={20} className="text-[var(--brand-primary)]" />
        <h1 className="font-display text-3xl text-white">Policy Pages</h1>
      </div>
      <p className="text-white/50 text-sm font-mono mb-6">
        Edit the copy shown on the public Privacy Policy, Shipping Policy and Returns & Warranty Policy pages (linked in the site footer).
      </p>
      <div className="max-w-2xl border-t border-[var(--border-default)]">
        {pages.map((p) => (
          <Link
            key={p.slug}
            to={`/admin/legal-pages/${p.slug}`}
            data-testid={`admin-legal-page-row-${p.slug}`}
            className="flex items-center justify-between gap-4 border-b border-[var(--border-default)] py-4 hover:bg-[var(--bg-secondary)]/60 transition-colors"
          >
            <div>
              <p className="text-white font-medium">{p.title}</p>
              {p.updatedAt && (
                <p className="text-white/40 text-xs font-mono mt-1">
                  Updated {new Date(p.updatedAt).toLocaleDateString("en-NZ", { day: "numeric", month: "short", year: "numeric" })}
                </p>
              )}
            </div>
            <ArrowUpRight size={16} className="text-white/40 shrink-0" />
          </Link>
        ))}
      </div>
    </div>
  );
}
